<template>
	<div class="">
		<div class="b-order__priceItem b-order__priceItem_sum">
			<span v-html="loc.SOA_SUM_SUMMARY"></span>
			<span class="b-order__priceNum">
				<span>
					<span v-html="formatPrice(total.PRICE_WITHOUT_DISCOUNT_VALUE)"></span>
					<span class="icon icon--ruble b-order__currency"></span>
				</span>
			</span>
		</div>

		<div class="b-order__priceItem b-order__priceItem_discount" v-if="total.DISCOUNT_PRICE > 0">
			<span v-html="loc.SOA_SUM_DISCOUNT"></span>
			<span class="b-order__priceNum" >
				<span v-html="formatPrice(total.DISCOUNT_PRICE)"></span>
				<span class="icon icon--ruble b-order__currency"></span>
			</span>
		</div>

		<div class="b-order__priceItem b-order__priceItem_delivery">
			<span v-html="loc.SOA_SUM_DELIVERY"></span>
			<span class="b-order__priceNum">
				<span v-html="formatPrice(total.DELIVERY_PRICE)"></span>
				<span class="icon icon--ruble b-order__currency"></span>
			</span>
		</div>

		<div class="b-order__priceItem b-order__priceItem_deliveryDiscount">
			<span v-html="loc.SOA_SUM_DELIVERY_DISCOUNT"></span>
		</div>

		<slot name="coupon"></slot>

		<div class="b-order__priceItem b-order__priceItem_total">
			<span v-html="loc.SOA_SUM_IT"></span>
			<span class="b-order__priceNum">
				<span v-html="formatPrice(total.ORDER_TOTAL_PRICE)"></span>
				<span class="icon icon--ruble b-order__currency b-order__currency_total"></span>
			</span>
		</div>
	</div>
</template>

<script>
import {Vue} from "ui.vue";

export default {
	name: "OrderPriceBlock",
	mixins: [BX.Citrus.Vue.Component.FormatMixin],
	props: {
		total: {
			type: [Array, Object],
			default: () => {
			}
		},
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("SOA_SUM_");
		},
	},
}
</script>